import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import cx from 'classnames';

import Divider from 'components/shared/Divider';
import Icon from 'components/shared/Icon';
import DragHandleIcon from 'components/shared/Icon/icons/DragHandleIcon';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import Text from 'components/shared/Typography/Text';

import s from './RoomItem.module.css';
import * as t from './RoomItem.types';

export const RoomItem = (props: t.Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.room.id!,
  });
  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
    userSelect: 'none',
    pointerEvents: isDragging ? 'none' : undefined,
    opacity: isDragging ? 0.5 : undefined,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <div className={s.contentWrapper}>
        <div className={s.rowWrapper}>
          {!props.isSortingDisabled && (
            <div className={cx(s.dragHandle, s.dragHandlePadding, isDragging && s.dragHandleDragging)} {...listeners}>
              <DragHandleIcon />
            </div>
          )}

          <div className={s.wrapper}>
            <Text accent className={s.title}>
              {props?.room?.name}
            </Text>
            <div className={s.actions}>
              <div className={s.actionsContent}>
                <button
                  type="button"
                  className={cx(s.btn, props.isDisabled && s.disabled)}
                  disabled={props.isDisabled}
                  onClick={props.onEdit}
                >
                  <Text accent className={s.edit}>
                    Edit
                  </Text>
                </button>

                <button
                  type="button"
                  className={cx(s.btn, props.isDisabled && s.disabled)}
                  disabled={props.isDisabled}
                  onClick={props.onDelete}
                >
                  <Icon component={Trash2} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Divider />
    </div>
  );
};
